import { Component, Inject, Vue } from 'vue-property-decorator';
import DirectusService from '@/core/directus/directus.service';
import LanguageCode from '@/locale/language-code';
import CovidSanitaryMeasuresCMSModel from '@/visa-application/models/CovidSanitaryMeasuresCMSModel';
import CovidSanitaryMeasuresSlotCMSModel from '@/visa-application/models/CovidSanitaryMeasuresSlotCMSModel';

@Component
export default class CovidSanitaryMeasures extends Vue {
  public covidSanitaryMeasuresCmsData: CovidSanitaryMeasuresCMSModel = new CovidSanitaryMeasuresCMSModel();
  public contentSlotData: CovidSanitaryMeasuresSlotCMSModel[] = [];

  @Inject('directusService')
  private directusService: () => DirectusService;
  private issuer: string;
  private residenceCountryCode: string;
  private unwatchCurrentLanguage: Function;

  public beforeRouteEnter(to, from, next) {
    next(vm => {
      vm.issuer = to.params.issuer;
      vm.residenceCountryCode = to.params.residenceCountryCode;
      vm.unwatchCurrentLanguage = vm.$store.watch(
        () => vm.$store.getters.currentLanguage,
        currentLanguage => {
          vm.getContent(currentLanguage);
          vm.getContentSlot(currentLanguage);
        },
        { immediate: true }
      );
    });
  }

  public beforeDestroyed(): void {
    this.unwatchCurrentLanguage();
  }

  public getContent(currentLanguage: LanguageCode): void {
    this.directusService()
      .getCollection<CovidSanitaryMeasuresCMSModel>(
        CovidSanitaryMeasuresCMSModel,
        'covid_sanitary_measures',
        ['*', 'background_image.*', 'translation.*'],
        undefined,
        currentLanguage
      )
      .then((response: CovidSanitaryMeasuresCMSModel[]) => {
        this.covidSanitaryMeasuresCmsData = response[0];
        if (this.covidSanitaryMeasuresCmsData.bottom_button_link.length > 0) {
          this.covidSanitaryMeasuresCmsData.bottom_button_link =
            '/' + this.covidSanitaryMeasuresCmsData.bottom_button_link + '/' + this.residenceCountryCode + '/' + this.issuer;
        }
        this.$store.commit('metaInfo', {
          meta_title: this.covidSanitaryMeasuresCmsData.meta_title,
          meta_description: this.covidSanitaryMeasuresCmsData.meta_description,
          meta_keywords: this.covidSanitaryMeasuresCmsData.meta_keywords
        });
      })
      .catch(error => console.error(error));
  }

  public getContentSlot(currentLanguage: LanguageCode): void {
    this.directusService()
      .getCollection<CovidSanitaryMeasuresSlotCMSModel>(
        CovidSanitaryMeasuresSlotCMSModel,
        'covid_sanitary_measures_slot',
        ['*', 'image.*', 'translation.*'],
        undefined,
        currentLanguage
      )
      .then((response: CovidSanitaryMeasuresSlotCMSModel[]) => {
        this.contentSlotData = response;
      })
      .catch(error => console.error(error));
  }
}
